"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

function userAgentMiddleware(options) {
  return function (next) {
    return function (args) {
      var request = args.request;
      if (!protocol_http_1.HttpRequest.isInstance(request)) return next(args);
      var headers = request.headers;
      var userAgentHeader = options.runtime === "node" ? "user-agent" : "x-amz-user-agent";

      if (!headers[userAgentHeader]) {
        headers[userAgentHeader] = "" + options.defaultUserAgent;
      } else {
        headers[userAgentHeader] += " " + options.defaultUserAgent;
      }

      if (options.customUserAgent) {
        headers[userAgentHeader] += " " + options.customUserAgent;
      }

      return next(tslib_1.__assign(tslib_1.__assign({}, args), {
        request: request
      }));
    };
  };
}

exports.userAgentMiddleware = userAgentMiddleware;
exports.getUserAgentMiddlewareOptions = {
  name: "getUserAgentMiddleware",
  step: "build",
  tags: ["SET_USER_AGENT", "USER_AGENT"]
};

exports.getUserAgentPlugin = function (config) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(userAgentMiddleware(config), exports.getUserAgentMiddlewareOptions);
    }
  };
};